import { Button, Tooltip } from "@mantine/core";
import { Calculator } from "lucide-react";
import React from "react";

interface RecalculateSeatsButtonProps {
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  undoStack: any[];
  setUndoStack: React.Dispatch<React.SetStateAction<any[]>>;
  selectedDots: Record<string, any>;
  t: (key: string) => string;
}

const RecalculateSeatsButton: React.FC<RecalculateSeatsButtonProps> = ({
  data,
  setData,
  undoStack,
  setUndoStack,
  selectedDots,
  t,
}) => {
  const reCalculateSeats = () => {
    setUndoStack([...undoStack, data]);

    const newData = JSON.parse(JSON.stringify(data));

    selectedDots.forEach((selectedKey: string) => {
      const [section, row] = selectedKey.split(":");

      const rowSeats = Object.keys(newData.data)
        .filter((seatKey) => seatKey.startsWith(`${section}:${row}:`))
        .sort(
          (a, b) =>
            parseInt(a.split(":")[2], 10) - parseInt(b.split(":")[2], 10)
        );

      rowSeats.forEach((seatKey, index) => {
        const newSeatKey = `${section}:${row}:${index + 1}`;

        if (seatKey !== newSeatKey) {
          newData.data[newSeatKey] = newData.data[seatKey];
          delete newData.data[seatKey];
        }
      });
    });

    setData((prev: any) => ({ ...prev, data: newData.data }));
  };

  return (
    <Tooltip
      label={t("scheme.redactor.contextMenu.buttons.recalculateSelectDots")}
    >
      <Button
        size="compact-md"
        onClick={reCalculateSeats}
        variant="light"
        color="orange"
      >
        <Calculator size={22} />
      </Button>
    </Tooltip>
  );
};

export default React.memo(RecalculateSeatsButton);
